import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import { BinarySink } from 'app/model/pipeline/copysink/binary.sink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BinarySink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*'
    }
})
export class BinarySinkAdapter extends CopySinkAdapter<BinarySink, Model.BinarySink> {
    protected override async _toResource(model: BinarySink): Promise<Model.BinarySink> {
        const result: Model.BinarySink = {
            type: 'BinarySink'
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.BinarySink, owner: Activity): Promise<BinarySink> {
        const result = Owned.create<BinarySink>(Metamodel.modelFor(BinarySink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        return result;
    }
}
